export default __webpack_public_path__ + "static/media/img_18.e308ed99.JPG";